import { Box, Container, Stack, Tab, Tabs, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import BackButton from '../components/BackButton';
import CompletedSubmissions from './CompletedSubmission';
import PendingSubmissions from './PendingSubmissions';
import Page from '../components/Page';

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ py: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

function AssignmentPage() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (

        <Page title="Assignment">
            <Container maxWidth={"xl"}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
                    <Typography variant="h4" gutterBottom>
                        Assignment Submissions
                    </Typography>
                </Stack>
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        {/* <BackButton link={-1} /> */}
                        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                            <Tab label="PENDING" {...a11yProps(0)} />
                            <Tab label="COMPLETED" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <PendingSubmissions />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <CompletedSubmissions />
                    </CustomTabPanel>
                </Box>
            </Container>
        </Page>
    )
}

export default AssignmentPage